import { LoadingButton } from '@mui/lab';
import { Autocomplete, Stack, TextField } from '@mui/material';
import Proptypes from 'prop-types';

import { api as stockApi } from '../../store/domains/stock';
import Render from '../Render';
import { transferResponseHandler } from '../../utils/transferResponse';
import { useInput } from '../../hooks/useInput';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';

const StartPackForm = ({ handleClose, hubId, isTransfer }) => {
  const [minId, handleChangeMinId] = useInput();
  const [maxId, handleChangeMaxId] = useInput();
  const [partnerId, handleChange] = useAutoCompleteState();
  const [toPartner, handleChangeToPartner] = useAutoCompleteState();

  const [postStartPackWithRangeMutation, { isLoading }] = stockApi.usePostStartPackWithRange();

  const [postStartPackWithRangeTransferMutation, { isLoading: isLoadingTransfer }] =
    stockApi.usePostStartPackWithRangeTransfer();

  const { data: posManagerOrganizations } = stockApi.useGetPosManagerOrganizations(hubId, {
    skip: !hubId,
  });
  const { data: posManagerPartners } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });

  const onSubmit = () => {
    const data = {
      minId,
      maxId,
      partnerId,
      toPartner,
    };
    if (isTransfer) {
      postStartPackWithRangeTransferMutation(data)
        .unwrap()
        .then(transferResponseHandler)
        .finally(() => {
          handleClose();
        });
      return;
    }

    postStartPackWithRangeMutation(data)
      .unwrap()
      .finally(() => {
        handleClose();
      });
  };

  return (
    <>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField fullWidth placeholder="Min range" rows={4} value={minId} onChange={handleChangeMinId} />
      </Stack>
      <Stack spacing={3} sx={{ my: 2 }}>
        <TextField fullWidth rows={4} placeholder="Max range" value={maxId} onChange={handleChangeMaxId} />
      </Stack>

      <Autocomplete
        value={partnerId}
        onChange={handleChange}
        options={posManagerOrganizations || []}
        renderInput={(params) => <TextField {...params} label="Select Partner" />}
        fullWidth
      />
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <LoadingButton
        sx={{ my: 2 }}
        onClick={onSubmit}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={isLoading || isLoadingTransfer}
        disabled={isLoading || isLoadingTransfer}
      >
        Submit
      </LoadingButton>
    </>
  );
};
StartPackForm.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
};
export default StartPackForm;
